import React, {useEffect, useState} from 'react';
import s from './styles.module.css'
import {Slider} from "@mui/material";
import classNames from "classnames";
import {useLocalStorage} from "../../utils/useLocalStorage";

const InputRange = ({
                        title,
                        index,
                        selected,
                        setSelected,
                        valueCalculate,
                        resetCalculate,
                        startValue,
                        scoreId,
                        id,
                        setScore,
                        sendRequest,
                        updateDataValue,
                        selectedValues,
                        setNameSelected
                    }) => {
    const [value, setValue] = useState(startValue);

    useEffect(() => {
        if (selected === index) {
            setNameSelected(title);
            if (selectedValues.coach_type_id === 1) {
                setScore(scoreId);
            } else {
                setScore(scoreId);
            }
        }
    }, [selected]);

    useEffect(() => {
        updateDataValue(id, value)
    }, [value])

    useEffect(() => {
        if (selected === index) {
            setValue(valueCalculate === null ? value : valueCalculate)
        }
    }, [selected, valueCalculate])

    return (
        <div className={classNames(s.input_range)} onClick={() => {
            resetCalculate()
            setSelected(index)
        }}>
            <div className={classNames(s.header, selected === index && s.select)}>
                <div className={s.header_left}>
                    <span>{index}.</span>
                    <p>{title}</p>
                </div>
                <div className={s.header_right}>
                    {startValue === null ? '' : Number(value).toFixed(2)}
                </div>
            </div>

            <div className={classNames(s.range_box, selected === index && title !== 'SuCon' && s.select)}>
                <div className={classNames(s.range_box_tool, s.left)} onClick={() => {
                    if (value <= 0) return
                    if (title !== 'SuCon') {
                        setValue(value - 0.25)
                        sendRequest((value - 0.25).toFixed(2), scoreId, localStorage.getItem("token"));
                    }
                }}>−0.25
                </div>
                <div className={classNames(s.range)}>
                    <Slider
                        disabled={title === 'SuCon'}
                        onChange={(e) => {
                            setValue(e.target.value)
                            setSelected(index)
                        }}
                        onChangeCommitted={() => sendRequest(value, scoreId, localStorage.getItem("token"))}
                        value={Number(value)}
                        defaultValue={Number(value)}
                        step={0.25}
                        min={0}
                        max={10}
                    />

                    <div className={s.line}/>
                </div>
                <div className={classNames(s.range_box_tool, s.right)} onClick={() => {
                    if (value === 10) return
                    if (title !== 'SuCon') {
                        setValue(value + 0.25)
                        sendRequest((value + 0.25).toFixed(2), scoreId, localStorage.getItem("token"));
                    }
                }}>+0.25
                </div>
            </div>
        </div>
    );
};

export default InputRange;
